module.exports = __webpack_public_path__ + "public/SiteIcons/edit.png?f91744ec";